"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventPreviewEmailStatus = void 0;
var EventPreviewEmailStatus;
(function (EventPreviewEmailStatus) {
    EventPreviewEmailStatus["EmailNotSend"] = "email-not-send";
    EventPreviewEmailStatus["EmailScheduled"] = "email-scheduled";
    EventPreviewEmailStatus["EmailSend"] = "email-send";
})(EventPreviewEmailStatus = exports.EventPreviewEmailStatus || (exports.EventPreviewEmailStatus = {}));
//# sourceMappingURL=event-preview-email-state.js.map